import { Link } from 'react-router-dom';
import type { Game } from '@/mocks/games';

interface GameCardProps {
  game: Game;
}

function StarRating({ rating }: { rating: number }) {
  const fullStars = Math.floor(rating);
  const hasHalf = rating - fullStars >= 0.5;
  const stars = [];

  for (let i = 0; i < fullStars; i++) {
    stars.push(<i key={`full-${i}`} className="ri-star-fill text-primary-500 text-xs"></i>);
  }
  if (hasHalf) {
    stars.push(<i key="half" className="ri-star-half-fill text-primary-500 text-xs"></i>);
  }
  const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
  for (let i = 0; i < emptyStars; i++) {
    stars.push(<i key={`empty-${i}`} className="ri-star-line text-primary-500 text-xs"></i>);
  }

  return <div className="flex items-center gap-0.5">{stars}</div>;
}

export default function GameCard({ game }: GameCardProps) {
  return (
    <Link
      to={`/category/${game.categorySlug}`}
      className="group block bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={game.coverImage}
          alt={game.title}
          title={`${game.title} - h游戏推荐`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {game.featured && (
            <span className="px-2 py-0.5 text-[11px] font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
              精选
            </span>
          )}
          {game.hot && (
            <span className="px-2 py-0.5 text-[11px] font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
              热门
            </span>
          )}
        </div>
        <div className="absolute bottom-3 right-3 flex items-center gap-1.5 px-2 py-1 bg-background-950/70 backdrop-blur-sm rounded-md">
          <span className="text-xs font-semibold text-primary-400">{game.rating}</span>
        </div>
      </div>
      <div className="p-4">
        <h3 className="text-sm font-semibold text-foreground-950 mb-1.5 line-clamp-1 group-hover:text-primary-600 transition-colors font-heading">
          {game.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-3">
          {game.description}
        </p>
        <div className="flex items-center justify-between">
          <StarRating rating={game.rating} />
          <div className="flex flex-wrap gap-1">
            {game.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-1.5 py-0.5 text-[10px] bg-secondary-100 text-secondary-700 rounded whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </Link>
  );
}